<template>
    <div id="sundair-login" class="travelo-login-box sdr-box">
        <div class="seperator"><label>Hello, i am 'Direct'</label></div>
        <br />
        <form @submit.prevent="onSubmit">
            <div class="form-group">
                <input type="text" class="input-text full-width" placeholder="agency login" v-model="agency_login">
            </div>
            <div class="form-group">
                <input type="password" class="input-text full-width" placeholder="password" v-model="agency_password">
            </div>
            <div class="form-group">
                <input type="text" class="input-text full-width" placeholder="carrier" v-model="agency_carrier">
            </div>
            <br /><br />

            <button class="btn-medium uppercase full-width"><i class="soap-icon-trunk-1"></i>&nbsp;&nbsp;Lets go </button>
        </form>
        <div class="seperator"></div>
        <p>Don't have an account?&nbsp;&nbsp;<a class="goto-signup soap-popupbox">+49 30 53676791</a></p>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { CONF_LIST_ALLOWEDCARRIER }  from '../../../config.js';
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';
    import md5 from 'js-md5';


    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                language: {
                    en: 'Language',
                    de: 'Sprache',
                },
                // >>> ------------------------------------


                agency_login: '',
                agency_password: '',
                agency_carrier: '',
                // >>> ------------------------------------
                lang: 'de'
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setCurrentLocale',
                'actn_call_GetAgency', // call:
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc: Agencies Login.
            * Note: Logout in 'LanguageList.vue'
            * Note: Encrypt here (md5).
            *
            */
            onSubmit: function(submitEvent) {

                let me = this,
                    result = null;


                me.$toc('>>> shared/header/SundairLogin.vue >>> onSubmit');
                // >>> Guard ------------------------------
                result = CONF_LIST_ALLOWEDCARRIER.find(obj => {
                    return obj.carrier === this.agency_carrier.toUpperCase()
                });
                if (!result) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Carrier is not supported'
                    });
                    return;
                }

                // >>> Call/Login -------------------------
                if (this.agency_login !== '' && this.agency_password !== '' && this.agency_carrier !== '') {
                    this.actn_call_GetAgency({
                        username: this.agency_login,
                        password: md5(this.agency_password),
                        apikey: result.key
                    });
                }

            }, // eof onSubmit()

        }, // eo methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>

</style>